import { OrganizationKeyName } from "../../model/Organization";
import { UserTermListItem } from "../../service/api-response/UserTermListSuccessResponse";
import { UserTerm } from "../../service/api-response/UserTermSuccessResponse";
import { UserTermVersionListItem } from "../../service/api-response/UserTermVersionListSuccessResponse";
import { UserTermVersion } from "../../service/api-response/UserTermVersionSuccessResponse";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";

const arr: any = [];

export const listUserTerms = (
  state: RootState,
  org?: OrganizationKeyName
): UserTermListItem[] => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.userTerm.userTerms[org] ?? [];
};

export const userTerm = (
  state: RootState,
  org: OrganizationKeyName,
  userTermId: string
): UserTerm | undefined => {
  return state.userTerm.userTerm[org]?.[userTermId];
};

export const isLoadingUserTermList = (
  state: RootState,
  org?: OrganizationKeyName
): boolean => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.userTerm.isLoadingUserTerms[org];
};

export const listUserTermVersions = (
  state: RootState,
  org: OrganizationKeyName,
  userTermId: string
): UserTermVersionListItem[] => {
  return state.userTerm.userTermVersions[org]?.[userTermId] ?? arr;
};

export const userTermVersion = (
  state: RootState,
  org: OrganizationKeyName,
  userTermVersionId: string
): UserTermVersion | undefined => {
  return state.userTerm.userTermVersion[org]?.[userTermVersionId];
};
